/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ScrapedMatchDTO { 
    season: string;
    competition_id: number;
    category_id: number;
    gender_name: string;
    gender_id: number;
    match_day: number | null;
    match_title: string;
    team_local: string;
    team_away: string;
    video_url: string | null;
    acta_url: string;
}

